import React, { useEffect, useRef, useState } from "react";
import { useHistory } from "react-router-dom";
import Header from '../../containers/Header';
import Footer from '../../containers/Footer';
import { ApiService } from '../../containers/Services/apiservice';
import moment from "moment";
import { Watch } from "react-loader-spinner";
let apiServices = new ApiService();
const AllTransactions = () => {
  let history = useHistory();
  const didMountRef = useRef(true);
  const [transData, setTransData] = useState([])
  const [spinnerLoading, setSpinnerLoading] = useState(false);
  useEffect(() => {
    if (didMountRef.current) {
      setSpinnerLoading(true);
      const dataString = {
      }
      apiServices.getuseralltransactionsdata(dataString).then(res => {
        console.log(res)
        if (res.data.status == "success") {
          setTransData(res.data.data)
          setSpinnerLoading(false);
        }
        else if (res.data.status == "error" && res.data.message == "Session expired") {
          localStorage.removeItem('AUTH_TOKEN');
          // alert(res.data.message)
          setSpinnerLoading(false)
          history.push("/login")
        }
        else {
          alert(res.data.message)
          setSpinnerLoading(false)
        }
      })
    }
    didMountRef.current = false;
  })
  return (
    <>
      <Header />
      <section className='bg-gray-light section-small'>
        <div className={spinnerLoading == true ? 'parentDisable' : ''} width="100%">
          <div className='overlay-box'>
            <Watch
              color="#ffffff"
              visible={spinnerLoading}
            />
          </div>
        </div>
        <div className="container-fluid">
          <div className="row mg-t-20">
            {
              transData.length > 0 ?
                transData.map((value) => (
                  value.transactiondetail.map((key) => (
                    <div className='col-lg-12'>
                      <div className='mfsipbox mg-b-15' style={{ paddingBottom: "0px", paddingTop: "10px" }}>
                        <div className='mfsipbox-planname'>#{value.trans_order_no} ({key.txn_mf_name})</div>
                        <div className='mfshipboxform'>
                          <div className='row'>
                            {/* <div className='col-lg-6'>
             <div className='mfshipboxform-group'>
             Transaction Id : {key.txn_order_id}
             </div>
           </div> */}
                            {(() => {
                              if (value.trans_type == 'PUR') {
                                return (
                                  <> <div className='col-lg-6'>
                                    <div className='mfshipboxform-group'>
                                      Purchase Amount : ₹{key.txn_amount}
                                    </div>
                                  </div>
                                    <div className='col-lg-6'>
                                      <div className='mfshipboxform-group'>
                                        Transaction type : {value.trans_type}
                                      </div>
                                    </div></>);
                              }
                              else if (value.trans_type == 'SIP') {
                                return (
                                  <>
                                    <div className='col-lg-6'>
                                      <div className='mfshipboxform-group'>
                                        SIP Start On : {key.txn_sip_startday}/{key.txn_sip_startmonth}/{key.txn_sip_startyear}
                                      </div>
                                    </div>
                                    <div className='col-lg-6'>
                                      <div className='mfshipboxform-group'>
                                        SIP Amount : ₹ {key.txn_amount}
                                      </div>
                                    </div>
                                    <div className='col-lg-6'>
                                      <div className='mfshipboxform-group'>
                                        SIP Ends In : {key.txn_sip_endmonth}/{key.txn_sip_endyear}
                                      </div>
                                    </div>
                                    <div className='col-lg-6'>
                                      <div className='mfshipboxform-group'>
                                        Purchase Amount : {value.trans_type}
                                      </div>
                                    </div> </>
                                );
                              }
                              else if (value.trans_type == 'REDEEM') {
                                return (
                                  <>
                                    <div className='col-lg-6'>
                                      <div className='mfshipboxform-group'>
                                        FOLIO : {key.txn_folio_accno}
                                      </div>
                                    </div>
                                    <div className='col-lg-6'>
                                      <div className='mfshipboxform-group'>
                                        Transaction type : {value.trans_type}
                                      </div>
                                    </div>
                                    <div className='col-lg-6'>
                                      <div className='mfshipboxform-group'>
                                        Transaction Volume type : {key.txn_redeem_txntype}
                                      </div>
                                    </div>
                                    <div className='col-lg-6'>
                                      <div className='mfshipboxform-group'>
                                        Transaction Volume : {key.txn_amount}
                                      </div>
                                    </div>
                                  </>
                                )
                              }
                            })()}
                            <div className='col-lg-6'>
                              <div className='mfshipboxform-group'>
                                Transaction Date : {moment(value.created_at).format('YYYY-MM-DD')}
                              </div>
                            </div>
                            <div className='col-lg-6'>
                              <div className='mfshipboxform-group'>
                                Status :
                                {(() => {
                                  if (value.trans_status == 1) {
                                    return (
                                      <div className="badge bg-info">Transaction Processed</div>
                                    )
                                  } else if (value.trans_status == 2) {
                                    return (
                                      <div className="badge bg-danger">Transaction Failed</div>
                                    )
                                  } else if (value.trans_status == 3) {
                                    return (
                                      <div className="badge bg-success">Transaction Successfull</div>
                                    )
                                  } else {
                                    return (
                                      <div className="badge bg-warning">Transaction Pending</div>
                                    )
                                  }
                                })()}

                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>))
                )) : <div className='mfsipbox mg-b-15' style={{ paddingBottom: "0px", paddingTop: "10px" }}>
                  <div className='mfsipbox-planname'>No Transactions Found !</div>
                </div>}
          </div>
        </div>
      </section>
      <Footer />
    </>
  )
}
export default AllTransactions;